export default __webpack_public_path__ + "static/media/rosautodor.85a578e2.png";